import { Dropdown } from "@trafficsharkdsp/ui";
import { useTranslation } from "react-i18next";

import { parseManagerContact } from "../lib/parseManagerContact";

import cls from "./PersonalManagerDropdown.module.css";

import { useSessionStore } from "@/entities/session/models/store/useSessionStore";
import PersonalManagerIcon from "@/shared/assets/icons/personalManagerIcon.svg";

export const PersonalManagerDropdown = () => {
    const { t } = useTranslation();
    const { accountInfo } = useSessionStore();
    const support = accountInfo?.support;

    const fullName = [support?.first_name, support?.last_name].filter(Boolean).join(" ").trim();
    const email = support?.email?.trim();
    const contact = parseManagerContact(support?.contact);

    const hasData = Boolean(fullName || email || contact);

    const content = hasData ? (
        <div className={cls.card}>
            <span className={cls.title}>
                {t("header.personal-manager.title", { defaultValue: "Your personal manager" })}
            </span>
            {fullName && <p className={cls.name}>{fullName}</p>}
            {email && (
                <div className={cls.row}>
                    <span className={cls["row-label"]}>Email:</span>
                    <a className={cls["row-value"]} href={`mailto:${email}`}>
                        {email}
                    </a>
                </div>
            )}
            {contact && (
                <div className={cls.row}>
                    {contact.label && <span className={cls["row-label"]}>{contact.label}:</span>}
                    <span className={cls["row-value"]}>{contact.value}</span>
                </div>
            )}
        </div>
    ) : (
        <div className={cls.empty}>
            {t("header.personal-manager.empty", { defaultValue: "Manager info is not available" })}
        </div>
    );

    const items = [{ key: "personal-manager-content", label: content }];

    return (
        <Dropdown
            listClassName={cls.dropdown}
            items={items}
            width="20rem"
            gap="2.35rem"
            position="rightBottom"
            aria-label="Manager"
            data-qa="header-manager-button"
            renderDropdown={(_, dropdownItems) => (
                <div>{dropdownItems?.map((item) => <span key={item.key}>{item.label}</span>)}</div>
            )}
        >
            <span className={cls.trigger}>
                <PersonalManagerIcon />
            </span>
        </Dropdown>
    );
};
